import React, { FC, useMemo } from 'react';
import { ProjectId } from 'api/models';
import {
  AssigneePickerFilter,
  useAssigneeOptions,
} from 'hooks/use-assignee-options';
import { useAssigneeOptionsSelectValue } from 'hooks/use-invite-user';
import { AssigneePicker, BaseProps } from './assignee-picker';

export type ProjectAssigneePickerProps = BaseProps & {
  projectId: ProjectId;
  hidePlaceholders?: boolean;
  dueDate?: string | null;
  startDate?: string | null;
  notIncludeRestrictedPartnerUser?: boolean;
};

export const ProjectAssigneePicker: FC<ProjectAssigneePickerProps> = (
  props,
) => {
  const {
    projectId,
    selectProps,
    isPrivate = false,
    dueDate,
    startDate,
    notIncludeRestrictedPartnerUser,
  } = props;
  const [, _projectId] = projectId;
  const userInviteHandler = useAssigneeOptionsSelectValue(projectId);

  const options = useAssigneeOptions({
    projectId,
    isPrivate,
    filter: AssigneePickerFilter.All,
    options: {
      includeRestricedPartnersMembers: !notIncludeRestrictedPartnerUser,
    },
  });

  const _selectProps = useMemo(
    () => ({
      ...selectProps,
      options,
    }),
    [options, selectProps],
  );

  return (
    <AssigneePicker
      {...props}
      selectProps={_selectProps}
      userInviteHandler={userInviteHandler}
      dueDate={dueDate}
      startDate={startDate}
    />
  );
};
